import { useEffect } from 'react';

const secretKey = import.meta.env.VITE_REACT_URL_SIGNATURE_SECRET_KEY;
// const dataKey = import.meta.env.VITE_REACT_SIGNATURE_DATA_KEY;
const dataKey = 'signature';

// Utility for XOR encryption/decryption
const xorEncrypt = (data, key) => {
  return data
    .split('')
    .map((char, i) => String.fromCharCode(char.charCodeAt(0) ^ key.charCodeAt(i % key.length)))
    .join('');
};

const xorDecrypt = (data, key) => xorEncrypt(data, key);

// Encrypt query params
export const encryptQueryParams = (params) => {
  console.log('params', params);
  const stringifiedParams = JSON.stringify(params);

  // const xorEncrypted = xorEncrypt(stringifiedParams, secretKey);
  // const base64Encoded = btoa(xorEncrypted);
  // return `${dataKey}=${encodeURIComponent(base64Encoded)}`
  // return `${dataKey}=${base64Encoded}`;
  return `${dataKey}=${stringifiedParams}`;
};

// Decrypt query params
const decryptQueryParams = () => {
  const searchParams = new URLSearchParams(location.search);
  const encryptedParams = searchParams.get(dataKey);
  if (encryptedParams) {
    // const base64Decoded = atob(decodeURIComponent(encryptedParams))
    // const base64Decoded = atob(encryptedParams);
    // const decrypted = xorDecrypt(base64Decoded, secretKey);
    // return JSON.parse(decrypted);
    return JSON.parse(encryptedParams);
  }
  return {};
};

// Save query params in window.name
const saveQueryParams = () => {
  const params = new URLSearchParams(location.search);
  const dataKeyParam = params.get(dataKey);
  if (dataKeyParam) {
    const tabData = JSON.parse(window.name || '{}');
    tabData.savedQueryParams = `${dataKey}=${dataKeyParam}`;
    window.name = JSON.stringify(tabData);
  }
};

// Reapply query params from window.name
const reapplyQueryParams = () => {
  const tabData = JSON.parse(window.name || '{}');
  const savedParams = tabData.savedQueryParams;

  if (savedParams) {
    const currentUrl = new URL(window.location.href);
    const currentParams = new URLSearchParams(currentUrl.search);

    const savedParamsObj = new URLSearchParams(savedParams);

    for (const [key, value] of savedParamsObj.entries()) {
      currentParams.set(key, value);
    }

    currentUrl.search = currentParams.toString();
    window.history.replaceState(null, '', currentUrl.toString());
  }
};

// Combined function for saving and reapplying query params
const saveAndReapplyQueryParams = () => {
  saveQueryParams();
  reapplyQueryParams();
};

// Custom Hook
const useUrlQueryParams = ({ persist = false } = {}) => {
  useEffect(() => {
    if (persist) {
      saveAndReapplyQueryParams();
    }
  }, [location.href, location.search]);

  // Return the utility functions for external use
  return {
    encryptQueryParams,
    decryptQueryParams,
  };
};

export default useUrlQueryParams;
